/** Matches `ButtonTextIcon` horizontal padding (12px each side). */
const HORIZONTAL_PADDING_PX = 24;

/** 24px icon + 8px `startIcon` margin. */
const START_ICON_SLOT_PX = 32;

const FONT_SIZE_PX = 16;
const FONT_WEIGHT = 400;

function measureTextWidth(text: string, fontFamily: string): number {
  if (typeof document === 'undefined') {
    return text.length * 8;
  }

  const canvas = document.createElement('canvas');
  const context = canvas.getContext('2d');

  if (!context) {
    return text.length * 8;
  }

  context.font = `${FONT_WEIGHT} ${FONT_SIZE_PX}px ${fontFamily}`;
  return context.measureText(text).width;
}

export function measureButtonLabelWidth(
  label: string,
  fontFamily: string
): number {
  return Math.ceil(measureTextWidth(label, fontFamily));
}

/** Approximates rendered `ButtonTextIcon` width (icon + label + padding). */
export function estimateButtonTextIconWidth(
  label: string,
  fontFamily: string
): number {
  return Math.ceil(
    HORIZONTAL_PADDING_PX +
      START_ICON_SLOT_PX +
      measureTextWidth(label, fontFamily)
  );
}
